module.exports = __webpack_public_path__ + "img/2022-Livestream-Thumbnail.3d94f7ce.png";